//import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import App from './App';
import './Styles/appStyles.css'
import { CustomThemeProvider } from './Styles/appTheme';
import { Provider } from 'react-redux';
import { Box } from '@mui/material';
import configureAppStore from './Store/confgureAppStore.js'
import AppInsightsProvider from './components/applicationInsightsProvider.jsx';
import { SnackbarProvider } from "notistack";
const baseUrl = "App"
const rootElement = document.getElementById('root');
const reduxStore = configureAppStore();

ReactDOM.render(
  <Provider store={reduxStore}>

  <CustomThemeProvider>
    <CookiesProvider>
    <SnackbarProvider maxSnack={3} dense preventDuplicate >

    <BrowserRouter basename={baseUrl}>
    <AppInsightsProvider> 

    <Box sx={{ display: 'flex' }}>
    <App />
    </Box>
    </AppInsightsProvider>

    </BrowserRouter>
    </SnackbarProvider>
    </CookiesProvider>
  </CustomThemeProvider>
  </Provider>,
  rootElement);


